<h3 class="text-align-center">Decline booking</h3>

<div class="background-color-yellow padding-0-2" fxLayout="column">
    <p class="margin-top-2 text-align-center text-medium">
        Please give a reason for declining this booking.
    </p>

    <mat-form-field appearance="none" class="flok large margin-top-3">
        <mat-label>Reason</mat-label>

        <input [formControl]="reasonControl" matInput>
    </mat-form-field>

    <div class="margin-top-2" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="end center">
        <button (click)="cancel()" flok-button>Cancel</button>

        <div class="size-2"></div>

        <button (click)="decline()" color="accent" [disabled]="!reasonControl.valid" flok-button>Decline</button>
    </div>
</div>
